import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, BUTTON_TYPES, Popup, Typography } from '_atoms';
import { FeedbackCreation } from '_organisms/InterviewFeedback/FeedbackCreation';
import type {
  ImproveInterviewFeedbackCommentPayload,
  ImproveInterviewFeedbackCommentResponse,
} from 'actions/jobActions';
import type { InterviewFeedback } from 'store/reducers/jobReducer';
import './style.scss';

interface PopupCreateFeedbackUserData {
  full_name_latin?: string;
  full_name_local?: string;
  speciality?: string | null;
  link?: string;
}

interface PopupCreateFeedbackProps {
  open: boolean;
  feedback?: InterviewFeedback;
  userData: PopupCreateFeedbackUserData;
  onClose: () => void;
  onSave: (values: unknown) => void;
  onImproveComment: (
    body: ImproveInterviewFeedbackCommentPayload,
    signal: AbortSignal
  ) => Promise<ImproveInterviewFeedbackCommentResponse | null | undefined>;
}

export const PopupCreateFeedback: React.FC<PopupCreateFeedbackProps> = ({
  open,
  onClose,
  onSave,
  onImproveComment,
  feedback,
  userData,
}) => {
  const { t } = useTranslation();
  return (
    <Popup
      className="popup-create-feedback mobile-full-size"
      open={open}
      title={t('translation:popup_create_feedback.title')}
      onClose={onClose}
    >
      <div className="user-info">
        <Typography.Text className="user-info__title">{userData.full_name_latin}</Typography.Text>
        <Typography.Caption className="user-info__subtitle">{userData.full_name_local}</Typography.Caption>
        <Typography.Caption className="user-info__subtitle">{userData.speciality}</Typography.Caption>
        {userData.link && (
          <a target="_blank" href={userData.link} rel="noreferrer">
            <Button type={BUTTON_TYPES.TEXT}>{t('translation:popup_create_feedback.button_view')}</Button>
          </a>
        )}
      </div>
      <FeedbackCreation
        feedbackId={feedback?.uuid as string}
        initialValues={feedback as never}
        onFinish={values => onSave(values)}
        onImproveComment={onImproveComment}
        onCancel={onClose}
        approver={feedback?.approver}
        isPosted={undefined}
      />
    </Popup>
  );
};
